import { render, staticRenderFns } from "./MissWord.vue?vue&type=template&id=13d24c58"
import script from "./MissWord.vue?vue&type=script&lang=js"
export * from "./MissWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports